export default __webpack_public_path__ + "static/media/style9.e9de5bf9.svg";